import {dynamic} from '@github-ui/dynamic'
import {lazyWithPreload} from '@github-ui/react-core/lazy-with-preload'

// Keep the composer in SSR markup while allowing the client to warm its chunk before navigation.
export const IssueCommentComposer = dynamic(
  async () => {
    const module = await import('@github-ui/commenting/IssueCommentComposer')
    return {default: module.IssueCommentComposer}
  },
  {displayName: 'IssueCommentComposer'},
)

export const CreateIssueButton = lazyWithPreload(async () => {
  const module = await import('@github-ui/issue-create/CreateIssueButton')
  return {default: module.CreateIssueButton}
})

export const SubIssuesList = lazyWithPreload(async () => {
  const module = await import('@github-ui/sub-issues/SubIssuesList')
  return {default: module.SubIssuesList}
})

export async function preheatIssueViewerSecondaryComponents() {
  await Promise.all([IssueCommentComposer.preload(), CreateIssueButton.preload(), SubIssuesList.preload()])
}
